import { Toaster } from 'react-hot-toast';
import './App.css';
import Routing from './Routing';

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <Routing />
    </>
  );
}

export default App;
